import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Scatter Plot panel art: fourteen sessions plotted against two measures, with
 * a faint rising fit line behind them. Most points sit in the accent; a few
 * green and red outliers mark the days that ran hardest either way.
 */

/** [cx, cy, radius, fill] */
const POINTS: [number, number, number, string][] = [
  [24, 80, 3, 'hsl(var(--primary) / 0.7)'],
  [30, 58, 4, 'hsl(var(--primary) / 0.7)'],
  [40, 72, 3, 'hsl(var(--negative) / 0.75)'],
  [47, 44, 3, 'hsl(var(--primary) / 0.7)'],
  [58, 78, 4, 'hsl(var(--primary) / 0.7)'],
  [66, 52, 3, 'hsl(var(--primary) / 0.7)'],
  [74, 66, 4, 'hsl(var(--positive) / 0.75)'],
  [84, 30, 3, 'hsl(var(--primary) / 0.7)'],
  [92, 60, 4, 'hsl(var(--primary) / 0.7)'],
  [102, 22, 3, 'hsl(var(--negative) / 0.75)'],
  [112, 50, 4, 'hsl(var(--primary) / 0.7)'],
  [122, 38, 3, 'hsl(var(--positive) / 0.75)'],
  [134, 64, 4, 'hsl(var(--primary) / 0.7)'],
  [142, 26, 3, 'hsl(var(--positive) / 0.75)'],
]

export function ScatterArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <path
        d="M16 12 V86 H148"
        fill="none"
        stroke="hsl(var(--muted-foreground) / 0.3)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M20 76 L144 30"
        fill="none"
        stroke="hsl(var(--muted-foreground) / 0.4)"
        strokeWidth="2"
        strokeDasharray="4 4"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      {POINTS.map(([cx, cy, r, fill]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} fill={fill} />
      ))}
    </svg>
  )
}
